import * as actionTypes from "./TicketsTypes";
import { Post } from "../../helpers/apicalls/apicalls";

export const getTickets = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_TICKETS });
    Post("/agents/user/getTickets", data)
      .then(function (response) {
        if (response) {
          dispatch({
            type: actionTypes.GET_TICKETS_SUCCESS,
            payload: response?.data
          });
        } else {
          dispatch({ type: actionTypes.GET_TICKETS_FALED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_TICKETS_FALED });
      });
  };
};


export const getTicketsNoLoading = (data) => {
  return (dispatch) => {
    Post("/agents/user/getTickets", data)
      .then(function (response) {
        if (response) {
          dispatch({
            type: actionTypes.GET_TICKETS_SUCCESS,
            payload: response?.data
          });
        } else {
          dispatch({ type: actionTypes.GET_TICKETS_FALED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_TICKETS_FALED });
      });
  };
};

export const updateTickets = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_TICKETS });

    // Return the promise here ⬇️
    return Post("/agents/user/updateTickets", data)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.UPDATE_TICKETS_SUCCESS,
            payload: response?.data
          });
          return response;
        } else {
          dispatch({ type: actionTypes.UPDATE_TICKETS_FALED });
          return response;
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.UPDATE_TICKETS_FALED });
        return false;
      });
  };
};


export const updateTicketsRead = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_READ });
    // Return the promise here ⬇️
    return Post("/agents/user/updateTicketsRead", data)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_READ_SUCCESS,
            payload: response?.data
          });
          return response;
        } else {
          dispatch({ type: actionTypes.GET_READ_FALED });
          return response;
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_READ_FALED });
        return false;
      });
  };
};


